module.exports = __webpack_public_path__ + "assets/toolbar-edit-icon.e522bd25.svg";